import { FC } from 'react';
import { IconProps } from '../types';

export const CendIcon: FC<IconProps> = ({ width = 9, height = 16, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6250_7392)">
        <path
          d="M5.83729 2.12002C6.34396 2.13335 6.82396 2.20002 7.27729 2.32002C7.74396 2.42669 8.14396 2.55335 8.47729 2.70002L7.95729 4.16002C7.61063 4.02669 7.21729 3.90669 6.77729 3.80002C6.33729 3.69335 5.93729 3.64002 5.57729 3.64002C4.85729 3.64002 4.25729 3.79335 3.77729 4.10002C3.31063 4.39335 2.96396 4.84669 2.73729 5.46002C2.51063 6.06002 2.39729 6.82002 2.39729 7.74002C2.39729 8.66002 2.51063 9.41335 2.73729 10C2.97729 10.5867 3.32396 11.02 3.77729 11.3C4.24396 11.58 4.81729 11.72 5.49729 11.72C6.08396 11.72 6.59063 11.6667 7.01729 11.56C7.45729 11.44 7.88396 11.2933 8.29729 11.12V12.66C7.93729 12.8333 7.56396 12.9733 7.17729 13.08C6.79063 13.1733 6.33729 13.2333 5.81729 13.26V15.2H4.47729V13.2C3.69063 13.08 3.00396 12.82 2.41729 12.42C1.84396 12.02 1.39729 11.44 1.07729 10.68C0.75729 9.92002 0.59729 8.94669 0.59729 7.76002C0.59729 6.54669 0.75729 5.55335 1.07729 4.78002C1.39729 4.00669 1.85063 3.41335 2.43729 3.00002C3.02396 2.58669 3.70396 2.32002 4.47729 2.20002V0.52002H5.83729V2.12002Z"
          fill="#FFFFD7"
        />
      </g>
      <defs>
        <clipPath id="clip0_6250_7392">
          <rect width="8" height="16" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
